import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useIsClient } from 'usehooks-ts';
export const useClientSearchParams = () => {
  const $ = _c(4);
  const isClient = useIsClient();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = new URLSearchParams();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [searchParams, setSearchParams] = useState(t0);
  let t1;
  let t2;
  if ($[1] !== isClient) {
    t1 = () => {
      if (isClient) {
        setSearchParams(new URLSearchParams(window.location.search));
      }
    };
    t2 = [isClient];
    $[1] = isClient;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return searchParams;
};